import React, { FC } from "react";
import { withProcedureWraper } from "..";

export const SettingDocumentPage: FC = withProcedureWraper(() => {
  return <div className="SettingDocumentPage"></div>;
});
